/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
// alert("bootstrap.js");
window.$ = window.jQuery = require('jquery');
window.$ = $.extend(require('jqueryui'));
window.$ = $.extend(require("jqueryui/jquery-ui.min.css"));
window.$ = $.extend(require("jqueryui/jquery-ui.theme.min.css"));


// WEBPACK FOOTER //
// ./src/assets/js/bootstrap.js